'use strict';

function applySmartswitchOptions(target) {
  // SMARTSWITCH

  /**
   *  @prop {string} [smartswitch.configCode]
   * Config code for smartswitch
   * null by default
   */
  target['smartswitch.configCode'] = undefined;

  /**
   *  @prop {string} [smartswitch.groupCode]
   * Group code for smartswitch
   * null by default
   */
  target['smartswitch.groupCode'] = undefined;

  /**
   *  @prop {string} [smartswitch.contractCode]
   * Contract code for smartswitch
   * null by default
   */
  target['smartswitch.contractCode'] = undefined;
}

module.exports = applySmartswitchOptions;

